export const Directions = {
  UP: 'UP' as const,
  DOWN: 'DOWN' as const,
  LEFT: 'LEFT' as const,
  RIGHT: 'RIGHT' as const,
};

export const Rotations = {
  LEFT: 'LEFT' as const,
  RIGHT: 'RIGHT' as const,
};

export type Direction = keyof typeof Directions;
export type Rotation = keyof typeof Rotations;
